module.exports = __webpack_public_path__ + "img/ic_switch.35a2b9c2.svg";